// extracted by mini-css-extract-plugin
export default {"container_Dashboard":"style_container_Dashboard__noO-M","content_Dashboard":"style_content_Dashboard__XRnO9","dashboard_title":"style_dashboard_title__uwqFc"};